import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  Link
} from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent === null) {
      // Show banner with small delay for better UX
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'false');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 3,
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          maxWidth: 1200,
          mx: 'auto'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <CookieIcon color="primary" sx={{ fontSize: 40 }} />
          <Box>
            <Typography variant="body1" fontWeight="bold" gutterBottom>
              Мы используем cookies и Метрику для аналитики
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Продолжая использовать наш сайт, вы соглашаетесь с нашей{' '}
              <Link href="/privacy" color="primary">Политикой конфиденциальности</Link>
              {' '}и{' '}
              <Link href="/consent" color="primary">Согласием на обработку персональных данных</Link>
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexShrink: 0 }}>
          <Button 
            variant="outlined" 
            color="inherit" 
            onClick={handleDecline}
          >
            Отклонить
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleAccept}
          >
            Принять
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CookieConsentBanner;
